import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75364fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-toggle" }
const _hoisted_2 = ["id", "name", "value", "checked"]
const _hoisted_3 = ["for"]

import { defineModel } from "vue";

interface Props {
	name: string;
	valueA: string;
	valueB: string;
	labelA: string;
	labelB: string;
	idPrefix: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextToggle',
  props: /*#__PURE__*/_mergeModels({
    name: {},
    valueA: {},
    valueB: {},
    labelA: {},
    labelB: {},
    idPrefix: {}
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const model = _useModel(__props, "modelValue");

const toggleValues = [{
	value: props.valueA,
	label: props.labelA,
}, {
	value: props.valueB,
	label: props.labelB,
}];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toggleValues, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.value
      }, [
        _withDirectives(_createElementVNode("input", {
          id: _ctx.idPrefix + '-' + item.value,
          name: _ctx.name,
          class: "text-toggle__input",
          type: "radio",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
          value: item.value,
          checked: model.value === item.value
        }, null, 8, _hoisted_2), [
          [_vModelRadio, model.value]
        ]),
        _createElementVNode("label", {
          class: _normalizeClass({
					'text-toggle__label': true,
					'text-toggle__label--active': model.value === item.value,
				}),
          for: _ctx.idPrefix + '-' + item.value
        }, _toDisplayString(item.label), 11, _hoisted_3)
      ], 64))
    }), 64))
  ]))
}
}

})